import Cache from '@/utils/cache'

// 顶部企业登录与服务平台登录共用登录态写入方式。
export function saveLoginSession(store, data) {
  if (!data?.accessToken || !data.userInfo) {
    throw new Error('登录响应缺少登录凭证或用户信息')
  }
  Cache.set('personUser', data.userInfo)
  Cache.set('accessToken', data.accessToken)
  Cache.set('refreshToken', data.refreshToken)
  store.dispatch('setUser', data.userInfo)
}
